/**
 * What this account calls the probe reading: "Pipe Strap", "Wine Bottle"...,
 * or "Probe" until an admin names it (Settings › Display › Probe name). The
 * API puts the enterprise owner's setting on every login
 * (window.currentUser.probe_label), so team logins read it too. Only the
 * reading's name changes; the sensor's probe settings (thermocouple type,
 * calibration) keep the word "Probe".
 */

// the names the setting offers; an admin may also type their own
export const PROBE_LABEL_PRESETS = ['Probe', 'Pipe Strap', 'Pipe Clamp', 'Wine Bottle', 'Buffer Bottle'];

export const probeLabel = () => {
  const user = window.currentUser || {};
  const label = typeof user.probe_label === 'string' ? user.probe_label.trim() : '';

  return label || 'Probe';
};

// "Pipe Strap Temperature", "Probe Temperature"
export const probeTemperatureLabel = () => `${probeLabel()} Temperature`;

// "Pipe Strap Temp", "Probe Temp"
export const probeTempLabel = () => `${probeLabel()} Temp`;

export default probeLabel;
